export default __webpack_public_path__ + "static/media/ls2_g03.1e31def3.png";